module.exports = __webpack_public_path__ + "mo/img/piece-24.88ca9cec.svg";